import React, { useLayoutEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const ChartComponent = ({ data }) => {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    if (!data || !Array.isArray(data) || data.length === 0) return;

    const root = am5.Root.new(chartRef.current);
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: false,
        wheelX: "panX",
        wheelY: "zoomX",
        layout: root.verticalLayout,
      })
    );

    const xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        maxDeviation: 0.2,
        baseInterval: { timeUnit: "minute", count: 1 },
        renderer: am5xy.AxisRendererX.new(root, {}),
        tooltip: am5.Tooltip.new(root, {}),
        start: 0,
      })
    );

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0,
        max: 180,
        strictMinMax: true,
      })
    );

    const fields = [
      { key: "hr", name: "HR", color: am5.color(0xe6194b) },
      { key: "rr", name: "RR", color: am5.color(0x3cb44b) },
      { key: "hrv", name: "HRV", color: am5.color(0x4363d8) },
      { key: "sv", name: "SV", color: am5.color(0xffe119) },
      { key: "movement", name: "Hareket", color: am5.color(0xf58231) },
      { key: "relax", name: "Rahatlık", color: am5.color(0x911eb4) },
    ];

    const cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", true);

    const vitalData = data
      .filter((item) => item.time && item.hr !== undefined)
      .map((item) => ({
        time: new Date(item.time).getTime(),
        hr: item.hr,
        rr: item.rr,
        hrv: item.hrv,
        sv: item.sv,
        movement: item.movement,
        relax: item.relax,
      }));

    fields.forEach((field) => {
      const series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: field.name,
          xAxis,
          yAxis,
          valueYField: field.key,
          valueXField: "time",
          tooltip: am5.Tooltip.new(root, {
            labelText: `${field.name}: {valueY}`,
          }),
        })
      );

      series.strokes.template.setAll({
        strokeWidth: 2,
        stroke: field.color,
      });

      series.data.setAll(vitalData);
    });

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
      })
    );

    legend.data.setAll(chart.series.values);

    return () => {
      root.dispose();
    };
  }, [data]);

  return (
    <div
      id="chartdiv"
      ref={chartRef}
      style={{ width: "100%", height: "500px" }}
    ></div>
  );
};

export default ChartComponent;
